/**
 * Thin wrapper around window.gtag (GA4).
 *
 * gtag is loaded via a <script> tag in public/index.html and public/landing.html.
 * All functions are no-ops when gtag is not available (e.g. in tests / ad-blockers).
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
    dataLayer?: unknown[]
  }
}

const GA_ID = 'G-MWXXWSF2LC'

function gtag(...args: unknown[]): void {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args)
  }
}

/**
 * Fire a GA4 page_view event.
 * Call this on route changes.
 */
export function trackPageView(path: string, title?: string): void {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title ?? document.title,
    send_to: GA_ID
  })
}

/**
 * Fire a custom GA4 event.
 *
 * @param name   GA4 event name (snake_case recommended, max 40 chars)
 * @param params Optional event parameters
 */
export function trackEvent(
  name: string,
  params?: Record<string, unknown>
): void {
  gtag('event', name, { send_to: GA_ID, ...params })
}
